module.exports = __webpack_public_path__ + "media/images/icons/money_bag-8146e85d8d64b5606ae91cd696cd6d54.svg";